import { selectAuth } from './../redux/slices/authSlice';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectAdmins } from '../redux/slices/adminsSlice';

const usePermissions = () => {
  const { info } = useSelector(selectAdmins);
  const auth = useSelector(selectAuth);

  const isAllReadOnly = auth.info?.type === 'all_read_only' || info?.type === 'all_read_only' || info?.login === 'all_read_only';

  return React.useCallback(
    (code: string) =>
      auth.info?.type === 'superAdmin' ||
      isAllReadOnly ||
      info?.tabs.findIndex(tab => tab.code === code) !== -1,
    [auth.info, info, isAllReadOnly]
  );
};

export default usePermissions;
